// App.js
import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Navigate, useLocation, Route, Routes, matchPath } from 'react-router-dom';
import { routes } from './routes/routes';
import AppHeader from './header/header';
import { useEffect, useMemo, useRef, useState } from 'react';
import { UploadindexdbRecording } from './offlinestreaming/uploadrecordings';
import { unrestrictedRoutes } from './permisiions';
import { useDispatch } from 'react-redux';
import { clearConfig, fetchUserConfig, setConfig } from './reduxtoolkit/userconfigslice';
import api from './api/api';
import { CircularProgress, Box, Typography, Paper } from '@mui/material';
import { clearPrivileges, setHomescreen, setPayment, setPrivileges, setQa, setRpm, setTaskrpm } from './reduxtoolkit/userPrivileges';
import NotAllowedPage from './utils/reactpages/not allowed';
import GlobalToast from './utils/mui/globaltoast';
import { RecordingProvider } from './context/RecordingContext';
import FloatingRecorder from './components/FloatingRecorder/FloatingRecorder';
const App = () => {
  return (
    <div className="App bg-[#faf9fa] h-full">
      <RecordingProvider>
        <Router basename="/">
          <AppContent />
        </Router>
        <FloatingRecorder />
      </RecordingProvider>
    </div>
  );
};

export const invalidroutes = ["/auth"];

function AppContent() {
  const location = useLocation();
  const dispatch = useDispatch();
  const [currentPrivileges, setCurrentPrivileges] = useState([]);
  const [loading, setLoading] = useState(true);
  const currentPath = location.pathname;
  const practiseid = window.getPracticeId();
  const accessToken = localStorage.getItem('auth');
  const isCalledRef = useRef(false);
 const queryParams = useMemo(() => new URLSearchParams(window.location.search), []);
  const allowToken = queryParams.get('allowtoken'); // special flow token
  const headerParam = queryParams.get('hdr')
  const fetchUser = async () => {
     const isUnrestricted = unrestrictedRoutes.some(route => currentPath.startsWith(route));
    
    try {
       if (isUnrestricted) {
      dispatch(clearConfig());
      dispatch(clearPrivileges())
      return
    }
      const userRes = await api.get('/auth/me');
      const userPermissions = userRes?.permissions
        ? JSON.parse(userRes.permissions)
        : [];
      dispatch(setConfig(userRes));
      // Fetch privileges from backend
      const getAllPrivileges = await api.get(`/v1/${practiseid}/privileges/get`);
 if (getAllPrivileges.status === 200) {
  const allPrivileges = getAllPrivileges.data;

  // Side Bar
  const sidebarPrivileges = allPrivileges.filter(x => x.page === "Side Bar");
  const userSidebarPrivileges = sidebarPrivileges.filter(priv =>
    userPermissions.includes(priv.id.toString())
  );
  dispatch(setPrivileges(userSidebarPrivileges.map(x => x.privilege)));
  setCurrentPrivileges(userSidebarPrivileges.map(x => x.privilege));

  // Home Screen
  const homescreenPrivileges = allPrivileges.filter(x => x.page === "Home Screen");
  const userHomescreenPrivileges = homescreenPrivileges.filter(priv =>
    userPermissions.includes(priv.id.toString())
  );
  dispatch(setHomescreen(userHomescreenPrivileges.map(x => x.privilege)));
// Payments

const paymentPrivileges = allPrivileges.filter(x => x.page === "Payment");
const userPaymentPrivileges = paymentPrivileges.filter(priv =>
  userPermissions.includes(priv.id.toString())
);
// QA
const qaPrivileges = allPrivileges.filter(x => x.page === "QA");

const userQaPrivileges = qaPrivileges.filter(priv =>
  userPermissions.includes(priv.id.toString())
);

dispatch(setQa(userQaPrivileges.map(x => x.privilege)));
dispatch(setPayment(userPaymentPrivileges.map(x => x.privilege)));
  // Tasks
  const taskrpmPrivileges = allPrivileges.filter(x => x.page === "Tasks");

  const userTaskrpmPrivileges = taskrpmPrivileges.filter(priv =>
    userPermissions.includes(priv.id.toString())
  );
  dispatch(setTaskrpm(userTaskrpmPrivileges.map(x => x.privilege)));

  // RPM
  const rpmPrivileges = allPrivileges.filter(x => x.page === "RPM");
  const userRpmPrivileges = rpmPrivileges.filter(priv =>
    userPermissions.includes(priv.id.toString())
  );
  dispatch(setRpm(userRpmPrivileges.map(x => x.privilege)));
}

    } catch (error) {
      console.error('Error fetching user:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, [location.pathname]);

  useEffect(() => {
    const isUnrestricted = unrestrictedRoutes.some(route => currentPath.startsWith(route));
    if (isUnrestricted) {
      dispatch(clearConfig());
    } else {
      // dispatch(fetchUserConfig());
    }
  }, [dispatch, currentPath]);

  // useEffect(() => {
  //   if (!isCalledRef.current) {
  //     isCalledRef.current = true;
  //     UploadindexdbRecording();
  //   }
  // }, []);
useEffect(() => {
  // Always call on page reload
  UploadindexdbRecording();

  const handleOnline = () => {
    // Call again when internet comes back
    UploadindexdbRecording();
  };

  window.addEventListener("online", handleOnline);

  return () => {
    window.removeEventListener("online", handleOnline);
  };
}, []);

  // Redirect if restricted route & no auth
  const isUnrestrictedRoute = unrestrictedRoutes.some(route =>
    location.pathname.startsWith(route)
  );
  if (!isUnrestrictedRoute && !accessToken) {
    return <Navigate to="/login" />;
  }

  // Show loader until privileges are fetched
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // Not allowed component (full-page, no header)

  // Function to map and render routes with privilege checks
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.path) {
        // If privilege required, check it
        if (route.privilege && !currentPrivileges.includes(route.privilege)) {
          return <Route key={route.path} path={route.path} element={<NotAllowedPage/>} />;
        }
        return <Route path={route.path} element={<route.component />} key={route.path} />;
      }
      return <Route path={route.path} element={<NotAllowedPage />} key={route.path} />;
    });

  // Find current route & check privileges for header
  const currentRoute = routes.find(route => matchPath(route.path, location.pathname));
  const hasPrivilege =
    !currentRoute?.privilege || currentPrivileges.includes(currentRoute.privilege);
  const showHeader = currentRoute && currentRoute.showHeader && hasPrivilege;
const shouldShowHeader = showHeader && (!allowToken || (allowToken && headerParam));
  return (
    <>
      {shouldShowHeader&& <AppHeader />}
       <GlobalToast />
      <Routes>
        {getRoutes(routes)}
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="*" element={<>Page not available</>} />
      </Routes>
    </>
  );
}

export default App;
